import { InjectionToken } from '@angular/core';
import { IConfigService } from './config-service-interface';

export const CONFIG_SERVICE = new InjectionToken<IConfigService>(
  'CONFIG_SERVICE'
);
